module.exports = __webpack_public_path__ + "img/banner-3-ja.dd5a164f.png";